import { StatDisplay } from 'app/agriculture/components/StatDisplay/StatDisplay';
import { usePolygonSlope } from 'app/agriculture/forms/components/usePolygonSlope';
import { useParamsId } from 'app/agriculture/charts/useParamsId';
import { useEntity } from 'app/agriculture/queries/entities/useEntity';
import { PolygonEntityTypes } from 'app/agriculture/models/Entities';
import { PolylineLengthComponent } from 'app/agriculture/forms/components/polyline_length_component';
import { SimpleGrid } from 'app/agriculture/components/SimpleGrid/SimpleGrid';

interface PolygonContentProps {
    infraType: (typeof PolygonEntityTypes)[number];
}

export function PolygonContent({ infraType }: PolygonContentProps) {
    const id = useParamsId();
    const { geometry } = useEntity({ entityId: id, entityType: infraType });
    const [polygon] = geometry.coordinates;
    const polygonSlope = usePolygonSlope(polygon);
    if (!polygon) return null;

    return (
        <SimpleGrid columns={3}>
            <StatDisplay
                id="polygon-entity-slope-max"
                value={polygonSlope.max}
                name="Max slope"
                unit={polygonSlope.max == 'Unknown' ? '' : '°'}
                isCalculating={polygonSlope.isCalculating}
            />
            <StatDisplay
                id="polygon-entity-slope-average"
                value={polygonSlope.average}
                name="Average slope"
                unit={polygonSlope.average == 'Unknown' ? '' : '°'}
                isCalculating={polygonSlope.isCalculating}
            />
            {/* TODO: add area component */}
            <PolylineLengthComponent
                id="polygon-entity-perimiter-length"
                noun="Perimeter Length"
                line={polygon}
            />
        </SimpleGrid>
    );
}
